module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Pool_teracce_D2_cam3.f4a59678.jpg";